/* eslint-disable @typescript-eslint/no-unused-vars */
import { Redirect, Route, RouteProps } from "react-router-dom";
// import Layout from "view/layout/index";
import { Fragment } from "react";
import { useMemo } from "react";
import { Layout } from "components/Layout";
interface CustomRouteProps extends RouteProps {
  hasLayout?: boolean;
  component: any;
}

const DefaultLayout = ({ children }: any) => <Fragment>{children}</Fragment>;

export function CustomRoute({
  hasLayout = true,
  component: Component,
  ...rest
}: CustomRouteProps) {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return hasLayout ? (
          <Layout>
            <Component />
          </Layout>
        ) : (
          // </Layout>
          <DefaultLayout>
            <Component />
          </DefaultLayout>
        );
      }}
    />
  );
}
